import { useState } from "react";
import MissionWater from "./MissionWater";
import MissionQuality from "./MissionQuality";
import MissionIssue from "./MissionIssue";
import { useNavigate } from "react-router-dom";
import MissionServiceAvizeau from "./MissionServiceAvizeau";

const MissionNavigationMenu = () => {
  const [activeSection, setActiveSection] = useState("eau");
  const navigate = useNavigate();
  const handleSectionChange = (section: any) => {
    setActiveSection(section);
    navigate(`/missions?${section}`);
  };

  return (
    <>
      <div className="flex flex-col items-center mt-5 ">
        <div className="flex justify-center space-x-4">
          <div
            className={`cursor-pointer  text-xs md:text-base   ${
              activeSection === "eau"
                ? "text-black font-bold   text-xs md:text-base  "
                : ""
            }`}
            onClick={() => handleSectionChange("eau")}
          >
            Eau potable
            <hr
              className={
                activeSection === "eau" ? "bg-primary   h-1 z-10" : "hidden"
              }
            />
          </div>
          <div
            className={`cursor-pointer  text-xs md:text-base  ${
              activeSection === "controle-qualite"
                ? "text-black font-bold  text-xs md:text-base   "
                : ""
            }`}
            onClick={() => handleSectionChange("controle-qualite")}
          >
            Contrôle et qualité
            <hr
              className={
                activeSection === "controle-qualite"
                  ? "bg-primary   h-1 z-10"
                  : "hidden"
              }
            />
          </div>
          <div
            className={`cursor-pointer  text-xs md:text-base  ${
              activeSection === "maitrise-des-fruites"
                ? "text-black font-bold  text-xs md:text-base  "
                : ""
            }`}
            onClick={() => handleSectionChange("maitrise-des-fruites")}
          >
            Maitrise des fuites 
            <hr
              className={
                activeSection === "maitrise-des-fruites"
                  ? "bg-primary   h-1 z-10"
                  : "hidden"
              }
            />
          </div>
          <div
            className={`cursor-pointer  text-xs md:text-base  ${
              activeSection === "avizeau"
                ? "text-black font-bold  text-xs md:text-base  "
                : ""
            }`}
            onClick={() => handleSectionChange("avizeau")}
          >
            Service Aviz'eau
            <hr
              className={
                activeSection === "avizeau" ? "bg-primary   h-1 z-10" : "hidden"
              }
            />
          </div>
        </div>
        <div className="z-0 w-[570px] max-w-2xl border-t border-gray-200 dark:border-gray-800" />
      </div>

      {activeSection === "eau" && <MissionWater />}
      {activeSection === "controle-qualite" && <MissionQuality />}
      {activeSection === "maitrise-des-fruites" && <MissionIssue />}
      {activeSection === "avizeau" && <MissionServiceAvizeau />}
    </>
  );
};

export default MissionNavigationMenu;
